import { jsx } from 'react/jsx-runtime';
import { Badge } from '../../display/Badge/Badge.es.js';

function PageNavigationBadge(props) {
  return jsx("span", { "data-zds": true, children: jsx(Badge, Object.assign({}, props)) });
}

export { PageNavigationBadge as default };
//# sourceMappingURL=PageNavigationBadge.es.js.map
